import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGasBlower = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 72.31,
	height: 67,
	viewBox: "0 0 72.31 67.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 22.0 54.0 L 10.0 67.0 L 70.0 67.0 L 58.0 54.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 0.0 0.0 L 40.0 0.0 A 30.0 30.0 0.0 1 1 11.5 20.0 L 0.0 19.75 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 40,
			cy: 30,
			rx: 10,
			ry: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgGasBlower;
